import * as Icons from "@/assets/features/sidebar";
import CountriesToCities from "@/lib/countriesToCities.json";
export const NAV_ITMES = [
  { label: "sidebar.dashboard", icon: Icons.Dashboard, path: "/dashboard" },
  {
    label: "sidebar.clientBoard",
    icon: Icons.ClientBoard,
    path: "/client-board",
  },
  {
    label: "sidebar.requisition",
    icon: Icons.Requisition,
    path: "/requisition",
  },
  {
    label: "sidebar.jobRequests",
    icon: Icons.JobRequets,
    path: "/job-requets",
  },
  {
    label: "sidebar.evaluationForms",
    icon: Icons.EvaluationForms,
    path: "/evaluation-forms",
  },
  { label: "sidebar.positions", icon: Icons.Positions, path: "/positions" },
  {
    label: "sidebar.candidates",
    icon: Icons.Candidates,
    path: "/candidates-managment",
  },
  { label: "sidebar.reports", icon: Icons.Reports, path: "/reports" },
  { label: "sidebar.settings", icon: Icons.Settings, path: "/settings" },
  {
    label: "sidebar.dataManagement",
    icon: Icons.DataManagment,
    path: "/data-managment",
  },
];

export const COLORS_CLASSESS = [
  "bg-blue-600",
  "bg-red-600",
  "bg-green-600",
  "bg-yellow-600",
  "bg-pink-600",
  "bg-purple-600",
  "bg-indigo-600",
  "bg-emerald-600",
  "bg-orange-600",
]

export const LANGUAGES = [
  { value: "AF", en: "Afrikaans", ar: "أفريقية", gr: "Afrikaans" },
  { value: "SQ", en: "Albanian", ar: "ألبانية", gr: "Albanisch" },
  { value: "AR", en: "Arabic", ar: "عربى", gr: "Arabisch" },
  { value: "HY", en: "Armenian", ar: "أرمينية", gr: "Armenisch" },
  { value: "EU", en: "Basque", ar: "باسكي", gr: "Baskisch" },
  { value: "BN", en: "Bengali", ar: "البنغالية", gr: "Bengalisch" },
  { value: "BG", en: "Bulgarian", ar: "البلغارية", gr: "Bulgarisch" },
  { value: "CA", en: "Catalan", ar: "الكتالانية", gr: "Katalanisch" },
  { value: "KM", en: "Cambodian", ar: "كمبودية", gr: "Kambodschanisch" },
  {
    value: "ZH",
    en: "Chinese (Mandarin)",
    ar: "صيني",
    gr: "Chinesisch (Mandarin)",
  },
  { value: "HR", en: "Croatian", ar: "الكرواتية", gr: "Kroatisch" },
  { value: "CS", en: "Czech", ar: "التشيكية", gr: "Tschechisch" },
  { value: "DA", en: "Danish", ar: "الدنماركية", gr: "Dänisch" },
  { value: "NL", en: "Dutch", ar: "هولندي", gr: "Niederländisch" },
  { value: "EN", en: "English", ar: "إنجليزية", gr: "Englisch" },
  { value: "ET", en: "Estonian", ar: "الإستونية", gr: "Estnisch" },
  { value: "FJ", en: "Fiji", ar: "فيجي", gr: "Fidschi" },
  { value: "FI", en: "Finnish", ar: "الفنلندية", gr: "Finnisch" },
  { value: "FR", en: "French", ar: "الفرنسية", gr: "Französisch" },
  { value: "KA", en: "Georgian", ar: "الجورجية", gr: "Georgisch" },
  { value: "DE", en: "German", ar: "ألمانية", gr: "Deutsch" },
  { value: "EL", en: "Greek", ar: "اليونانية", gr: "Griechisch" },
  { value: "GU", en: "Gujarati", ar: "الغوجاراتية", gr: "Gujarati" },
  { value: "HE", en: "Hebrew", ar: "العبرية", gr: "Hebräisch" },
  { value: "HI", en: "Hindi", ar: "الهندية", gr: "Hindi" },
  { value: "HU", en: "Hungarian", ar: "المجرية", gr: "Ungarisch" },
  { value: "IS", en: "Icelandic", ar: "الأيسلندية", gr: "Isländisch" },
  { value: "ID", en: "Indonesian", ar: "الأندونيسية", gr: "Indonesisch" },
  { value: "GA", en: "Irish", ar: "الأيرلندية", gr: "Irisch" },
  { value: "IT", en: "Italian", ar: "الإيطالية", gr: "Italienisch" },
  { value: "JA", en: "Japanese", ar: "اليابانية", gr: "Japanisch" },
  { value: "JW", en: "Javanese", ar: "الجاوية", gr: "Javanisch" },
  { value: "KO", en: "Korean", ar: "الكورية", gr: "Koreanisch" },
  { value: "LA", en: "Latin", ar: "لاتينية", gr: "Latein" },
  { value: "LV", en: "Latvian", ar: "اللاتفية", gr: "Lettisch" },
  { value: "LT", en: "Lithuanian", ar: "الليتوانية", gr: "Litauisch" },
  { value: "MK", en: "Macedonian", ar: "المقدونية", gr: "Mazedonisch" },
  { value: "MS", en: "Malay", ar: "الماليزية", gr: "Malaiisch" },
  { value: "ML", en: "Malayalam", ar: "المالايالامية", gr: "Malayalam" },
  { value: "MT", en: "Maltese", ar: "المالطية", gr: "Maltesisch" },
  { value: "MI", en: "Maori", ar: "الماوري", gr: "Maori" },
  { value: "MR", en: "Marathi", ar: "الماراثية", gr: "Marathi" },
  { value: "MN", en: "Mongolian", ar: "المنغولية", gr: "Mongolisch" },
  { value: "NE", en: "Nepali", ar: "النيبالية", gr: "Nepali" },
  { value: "NO", en: "Norwegian", ar: "النرويجية", gr: "Norwegisch" },
  { value: "FA", en: "Persian", ar: "الفارسية", gr: "Persisch" },
  { value: "PL", en: "Polish", ar: "البولندية", gr: "Polnisch" },
  { value: "PT", en: "Portuguese", ar: "البرتغالية", gr: "Portugiesisch" },
  { value: "PA", en: "Punjabi", ar: "البنجابية", gr: "Punjabi" },
  { value: "QU", en: "Quechua", ar: "الكويتشوا", gr: "Quechua" },
  { value: "RO", en: "Romanian", ar: "الرومانية", gr: "Rumänisch" },
  { value: "RU", en: "Russian", ar: "الروسية", gr: "Russisch" },
  { value: "SM", en: "Samoan", ar: "السامواية", gr: "Samoanisch" },
  { value: "SR", en: "Serbian", ar: "الصربية", gr: "Serbisch" },
  { value: "SK", en: "Slovak", ar: "السلوفاكية", gr: "Slowakisch" },
  { value: "SL", en: "Slovenian", ar: "السلوفينية", gr: "Slowenisch" },
  { value: "ES", en: "Spanish", ar: "الإسبانية", gr: "Spanisch" },
  { value: "SW", en: "Swahili", ar: "السواحلية", gr: "Swahili" },
  { value: "SV", en: "Swedish ", ar: "السويدية", gr: "Schwedisch" },
  { value: "TA", en: "Tamil", ar: "التاميلية", gr: "Tamilisch" },
  { value: "TT", en: "Tatar", ar: "التتارية", gr: "Tatarisch" },
  { value: "TE", en: "Telugu", ar: "التيلجو", gr: "Telugu" },
  { value: "TH", en: "Thai", ar: "التايلاندية", gr: "Thailändisch" },
  { value: "BO", en: "Tibetan", ar: "التبتية", gr: "Tibetisch" },
  { value: "TO", en: "Tonga", ar: "تونغا", gr: "Tonga" },
  { value: "TR", en: "Turkish", ar: "التركية", gr: "Türkisch" },
  { value: "UK", en: "Ukrainian", ar: "الأوكرانية", gr: "Ukrainisch" },
  { value: "UR", en: "Urdu", ar: "الأردية", gr: "Urdu" },
  { value: "UZ", en: "Uzbek", ar: "الأوزبكية", gr: "Usbekisch" },
  { value: "VI", en: "Vietnamese", ar: "الفيتنامية", gr: "Vietnamesisch" },
  { value: "CY", en: "Welsh", ar: "الويلزية", gr: "Walisisch" },
  { value: "XH", en: "Xhosa", ar: "الخوسا", gr: "Xhosa" },
];

export const EDUCATION_LEVEL = [
  {
    value: "UNDERGRAD",
    en: "Undergraduate",
    ar: "المرحلة الجامعية",
    gr: "Hochschüler",
  },
  { value: "BACHELOR", en: "Bachelor", ar: "بكالوريوس", gr: "Bachelor" },
  { value: "MASTER", en: "Master's Degree", ar: "الماجستير", gr: "Master" },
  { value: "DOCTORATE", en: "Doctorate Degree", ar: "دكتوراه", gr: "Doktorat" },
];

export const COUNTRIES = Object.keys(CountriesToCities).map((country) => ({
  value: country,
  label: country,
  cities: CountriesToCities[country].map((city) => ({
    value: city,
    label: city,
  })),
}));

export const CURRENCIES = [
  { value: "USD", label: "USD" },
  { value: "CAD", label: "CAD" },
  { value: "MXN", label: "MXN" },
  { value: "BBD", label: "BBD" },
  { value: "BSD", label: "BSD" },
  { value: "BRL", label: "BRL" },
  { value: "ARS", label: "ARS" },
  { value: "CLP", label: "CLP" },
  { value: "COP", label: "COP" },
  { value: "PEN", label: "PEN" },
  { value: "UYU", label: "UYU" },
  { value: "EUR", label: "EUR" },
  { value: "GBP", label: "GBP" },
  { value: "CHF", label: "CHF" },
  { value: "SEK", label: "SEK" },
  { value: "NOK", label: "NOK" },
  { value: "DKK", label: "DKK" },
  { value: "PLN", label: "PLN" },
  { value: "CZK", label: "CZK" },
  { value: "HUF", label: "HUF" },
  { value: "RON", label: "RON" },
  { value: "TRY", label: "TRY" },
  { value: "AED", label: "AED" },
  { value: "SAR", label: "SAR" },
  { value: "QAR", label: "QAR" },
  { value: "KWD", label: "KWD" },
  { value: "OMR", label: "OMR" },
  { value: "BHD", label: "BHD" },
  { value: "EGP", label: "EGP" },
  { value: "JOD", label: "JOD" },
  { value: "ILS", label: "ILS" },
  { value: "LBP", label: "LBP" },
  { value: "ZAR", label: "ZAR" },
  { value: "NGN", label: "NGN" },
  { value: "KES", label: "KES" },
  { value: "GHS", label: "GHS" },
  { value: "MAD", label: "MAD" },
  { value: "TND", label: "TND" },
  { value: "ETB", label: "ETB" },

  // 🟫 Asia
  { value: "INR", label: "INR" },
  { value: "PKR", label: "PKR" },
  { value: "BDT", label: "BDT" },
  { value: "LKR", label: "LKR" },
  { value: "NPR", label: "NPR" },
  { value: "CNY", label: "CNY" },
  { value: "JPY", label: "JPY" },
  { value: "KRW", label: "KRW" },
  { value: "HKD", label: "HKD" },
  { value: "SGD", label: "SGD" },
  { value: "MYR", label: "MYR" },
  { value: "THB", label: "THB" },
  { value: "IDR", label: "IDR" },
  { value: "VND", label: "VND" },
  { value: "PHP", label: "PHP" },
  { value: "AUD", label: "AUD" },
  { value: "NZD", label: "NZD" },
  { value: "FJD", label: "FJD" },
  { value: "PGK", label: "PGK" },
];

export const STAGES = [
   {
    value: "sourcing",
    label: "Sourcing Candidates",
    status: [
      {
        color: "#F1B44C",
        name: "Matched",
      },
      {
        color: "#17B179",
        name: "Applied",
      },
      {
        color: "#000000",
        name: "Eliminated",
      },
      {
        color: "#831117",
        name: "Disqualified",
      },
      {
        color: "#D64242",
        name: "Blacklisted",
      },
      {
        color: "#014B14",
        name: "Recommended",
      },
      
    ],
  },
  {
    value: "interview",
    label: "Talentino Screening Interview",
    status: [
      {
        color: "#17B179",
        name: "Invited",
      },
      {
        color: "#000000",
        name: "Declined",
      },
      {
        color: "#076698",
        name: "Scheduled",
      },
      {
        color: "#17B179",
        name: "Interviewed",
      },
      {
        color: "#D64242",
        name: "No Show",
      },
      {
        color: "#34C38F",
        name: "Passed",
      },
      {
        color: "#D64242",
        name: "Failed",
      },
    ],
  },
  {
    value: "video interview",
    label: "Talentino Video Interview",
    status: [
      {
        color: "#17B179",
        name: "Invited",
      },
      {
        color: "#000000",
        name: "Declined",
      },
      {
        color: "#076698",
        name: "Scheduled",
      },
      {
        color: "#17B179",
        name: "Interviewed",
      },
      {
        color: "#D64242",
        name: "No Show",
      },
      {
        color: "#34C38F",
        name: "Passed",
      },
      {
        color: "#D64242",
        name: "Failed",
      },
    ],
  },
  {
    value: "text interview",
    label: "Talentino Text Interview",
    status: [
      {
        color: "#17B179",
        name: "Invited",
      },
      {
        color: "#000000",
        name: "Declined",
      },
      {
        color: "#076698",
        name: "Scheduled",
      },
      {
        color: "#17B179",
        name: "Interviewed",
      },
      {
        color: "#D64242",
        name: "No Show",
      },
      {
        color: "#34C38F",
        name: "Passed",
      },
      {
        color: "#D64242",
        name: "Failed",
      },
    ],
  },
  {
    value: "form interview",
    label: "Talentino Form Interview",
    status: [
      {
        color: "#17B179",
        name: "Invited",
      },
      {
        color: "#000000",
        name: "Declined",
      },
      {
        color: "#076698",
        name: "Scheduled",
      },
      {
        color: "#17B179",
        name: "Interviewed",
      },
      {
        color: "#D64242",
        name: "No Show",
      },
      {
        color: "#34C38F",
        name: "Passed",
      },
      {
        color: "#D64242",
        name: "Failed",
      },
    ],
  },
  {
    value: "in-person",
    label: "Talentino In-Person Interview",
    status: [
      {
        color: "#17B179",
        name: "Invited",
      },
      {
        color: "#000000",
        name: "Declined",
      },
      {
        color: "#076698",
        name: "Scheduled",
      },
      {
        color: "#17B179",
        name: "Interviewed",
      },
      {
        color: "#D64242",
        name: "No Show",
      },
      {
        color: "#34C38F",
        name: "Passed",
      },
      {
        color: "#D64242",
        name: "Failed",
      },
    ],
  },
  {
    value: "scheduling",
    label: "Interview Scheduling",
   
  },
  {
    value: "cover letter interview",
    label: "Cover Letter Video Interview",
   
  },
  // {
  //   value: "document collection",
  //   label: "Collect Hiring Documents",
  //   status: [
  //     {
  //       color: "#F1B44C",
  //       name: "Document Requested",
  //     },
  //     {
  //       color: "#17B179",
  //       name: "Document Submitted",
  //     },
  //     {
  //       color: "#D64242",
  //       name: "No Document Submitted",
  //     },
  //     {
  //       color: "#076698",
  //       name: "Reminder Sent",
  //     },
  //     {
  //       color: "#831117",
  //       name: "Documents Insufficient",
  //     },
  //     {
  //       color: "#6C63FF",
  //       name: "Document Reviewed",
  //     },
  //     {
  //       color: "#34C38F",
  //       name: "Document Accepted",
  //     },
  //   ],
  // },
   {
    value: "reference",
    label: "Reference Check",
    status: [
      {
        color: "#17B179",
        name: "Reference Request Sent",
      },
      {
        color: "#F1B44C",
        name: "Waiting for Candidate Response",
      },
      {
        color: "#34C38F",
        name: "Reference Contacts Submitted",
      },
      {
        color: "#076698",
        name: "Waiting for Reference Response",
      },
      
      {
        color: "#831117",
        name: "Reference Completed",
      },
    ],
  },
  {
    value: "decision",
    label: "Hiring Decision",
    status: [
      {
        color: "#6C63FF",
        name: "Shortlisted",
      },
      {
        color: "#D64242",
        name: "Rejected",
      },
      {
        color: "#17B179",
        name: "Accepted",
      },
    ],
  },
  {
    value: "evaluation",
    label: "Evaluation",
    status: [
      {
        color: "#7CB9E8",
        name: "Evaluation Form Sent",
      },
      {
        color: "#17B179",
        name: "Evaluated",
      },
      {
        color: "#17B179",
        name: "Recommended",
      },
      {
        color: "#D64242",
        name: "Not Recommended",
      },
      {
        color: "#ECCB34",
        name: "Need Second Opinion",
      },
      {
        color: "#C2B280",
        name: "Evaluation Reminder",
      },
    ],
  },
  { value: "external onboarding", label: "External Onboarding" },
  {
    value: "offer",
    label: "Offer",
    status: [
      {
        color: "#17B179",
        name: "Offer Sent",
      },
      {
        color: "#6C63FF",
        name: "Offer Accepted",
      },
      {
        color: "#D64242",
        name: "Offer Declined",
      },
      {
        color: "#7CB9E8",
        name: "Negotiation",
      },
      {
        color: "#D64242",
        name: "No Reply",
      },
    ],
  },
   {
    value: "generic personal interview",
    label: "Generic Personal Interview",
    status: [
      {
        color: "#17B179",
        name: "Invited",
      },
      {
        color: "#000000",
        name: "Declined",
      },
      {
        color: "#7CB9E8",
        name: "Scheduled",
      },
      {
        color: "#17B179",
        name: "Interviewed",
      },
      {
        color: "#D64242",
        name: "No Show",
      },
       {
        color: "#17B179",
        name: "Passed",
      },
       {
        color: "#D64242",
        name: "Failed",
      },
    ],
  },
  { value: "noAuto", label: "None" },
];

// ============================= requirementns

export const EMPLOYMENT_TYPES = [
  { value: "Full-Time", en: "Full-Time", ar: "دوام كامل", gr: "Vollzeit" },
  { value: "Part-Time", en: "Part-Time", ar: "دوام جزئي", gr: "Teilzeit" },
  { value: "Freelance", en: "Freelance", ar: "عامل حر", gr: "Freiberuflich" },
  {
    value: "Project-Based",
    en: "Project-Based",
    ar: "قائم على المشروع",
    gr: "Projektbasiert",
  },
  { value: "Internship", en: "Internship", ar: "تدريب", gr: "Praktikum" },
];
export const HIRING_PRIORITY = [
  { value: "Low", en: "Low", ar: "طويل", gr: "LANG" },
  { value: "Medium", en: "Medium", ar: "عادي", gr: "Neutral" },
  { value: "High", en: "High", ar: "مرتفع", gr: "Hoch" },
];
export const REQUISITIONREASONS = [
  { value: "Expansion", en: "Expansion", ar: "توسع", gr: "Erweiterung" },
  { value: "Replacement", en: "Replacement", ar: "إستبدال", gr: "Ersatz" },
  {
    value: "Job Holder Transfer",
    en: "Job Holder Transfer",
    ar: "نقل صاحب العمل",
    gr: "Versetzung des Stelleninhabers",
  },
  {
    value: "Job Holder Demotion",
    en: "Job Holder Demotion",
    ar: "تخفيض رتبة صاحب الوظيفة",
    gr: "Herabstufung des Stelleninhabers",
  },
  {
    value: "Job Holder Promotion",
    en: "Job Holder Promotion",
    ar: "ترقية حامل الوظيفة",
    gr: "Beförderung von Stelleninhabern",
  },
];
export const TRAVEL = [
  { value: "0%", en: "0%", ar: "0%", gr: "0%" },
  { value: "30%", en: "30%", ar: "30%", gr: "30%" },
  { value: "50%", en: "50%", ar: "50%", gr: "50%" },
  { value: "100%", en: "100%", ar: "100%", gr: "100%" },
];

export const WORK_ENVIRONMENT_TYPE = [
  {
    value: "On-Site",
    en: "On-Site",
    ar: "في الموقع",
    gr: "Vor Ort",
  },
  {
    value: "Remote",
    en: "Remote",
    ar: "عن بُعد",
    gr: "Aus der Ferne",
  },
  { value: "Hybrid", en: "Hybrid", ar: "هجين", gr: "Hybrid" },
];

export const REPORTING_LINE_HIERARCHY = [
  { value: "Student", en: "Student", ar: "طالب", gr: "Student" },
  {
    value: "Entry Level",
    en: "Entry Level",
    ar: "مستوى مبتدئ",
    gr: "Einstiegsniveau",
  },
  { value: "Experienced", en: "Experienced", ar: "ذو خبرة", gr: "Erfahren" },
  {
    value: "Manager",
    en: "Manager",
    ar: "مدير",
    gr: "Manager",
  },
  {
    value: "Senior Manager",
    en: "Senior Manager",
    ar: "مدير أول",
    gr: "Senior Manager",
  },
  {
    value: "Not Specified",
    en: "Not Specified",
    ar: "غير محدد",
    gr: "Nicht angegeben",
  },
];

export const DURATION = [
  { en: "Week(s)", ar: "أسبوع", gr: "Woche(n)", value: "WEEKS" },
  { en: "Month(s)", ar: "شهر", gr: "Monat(e)", value: "MONTHS" },
  { en: "Year(s)", ar: "سنة", gr: "Jahr(e)", value: "YEARS" },
];

export const JOBCATEGORIES = [
  {
    value: "ACCOUNTING_FINANCE",
    en: "Accounting & Finance",
    ar: "المحاسبة والمالية",
    gr: "Rechnungswesen & Finanzen",
  },
  {
    value: "ADMINISTRATION_SUPPORT",
    en: "Administration & Office Support",
    ar: "الإدارة والدعم الإداري",
    gr: "Verwaltung & Büro-Support",
  },
  {
    value: "ADVERTISING_MEDIA",
    en: "Advertising, Arts & Media",
    ar: "الإعلان والفنون ووسائل الإعلام",
    gr: "Werbung, Kunst & Medien",
  },
  {
    value: "BANKING_SERVICES",
    en: "Banking & Financial Services",
    ar: "الخدمات المصرفية والمالية",
    gr: "Bankwesen & Finanzdienstleistungen",
  },
  {
    value: "CALL_CUSTOMER_SERVICE",
    en: "Call Centre & Customer Service",
    ar: "مركز الاتصال وخدمة العملاء",
    gr: "Callcenter & Kundenservice",
  },
  {
    value: "COMMUNITY_DEVELOPMENT",
    en: "Community Services & Development",
    ar: "خدمات المجتمع والتنمية",
    gr: "Gemeindedienste & Entwicklung",
  },
  { value: "CONSTRUCTION", en: "Construction", ar: "البناء", gr: "Bauwesen" },
  {
    value: "CONSULTING_STRATEGY",
    en: "Consulting & Strategy",
    ar: "استشارات واستراتيجية",
    gr: "Beratung & Strategie",
  },
  {
    value: "DESIGN_ARCHITECTURE",
    en: "Design & Architecture",
    ar: "التصميم والهندسة المعمارية",
    gr: "Design & Architektur",
  },
  {
    value: "EDUCATION_TRAINING",
    en: "Education & Training",
    ar: "التعليم والتدريب",
    gr: "Bildung & Training",
  },
  {
    value: "ENGINEERING",
    en: "Engineering",
    ar: "الهندسة",
    gr: "Ingenieurwesen",
  },
  {
    value: "HEALTHCARE_MEDICAL",
    en: "Healthcare & Medical",
    ar: "الرعاية الصحية والطبية",
    gr: "Gesundheitswesen & Medizin",
  },
  {
    value: "HOSPITALITY_TOURISM",
    en: "Hospitality & Tourism",
    ar: "الضيافة والسياحة",
    gr: "Gastgewerbe & Tourismus",
  },
  {
    value: "HUMAN_RESOURCES_RECRUITMENT",
    en: "Human Resources & Recruitment",
    ar: "الموارد البشرية والتوظيف",
    gr: "Personalwesen & Rekrutierung",
  },
  {
    value: "ICT",
    en: "Information & Communication Technology",
    ar: "تكنولوجيا المعلومات والاتصالات",
    gr: "Informationstechnologie & Kommunikation",
  },
  { value: "INSURANCE", en: "Insurance", ar: "التأمين", gr: "Versicherung" },
  { value: "LEGAL", en: "Legal", ar: "قانوني", gr: "Recht" },
  {
    value: "MANUFACTURING_LOGISTICS",
    en: "Manufacturing, Transport & Logistics",
    ar: "التصنيع والنقل والخدمات اللوجستية",
    gr: "Produktion, Transport & Logistik",
  },
  {
    value: "MARKETING_COMMUNICATIONS",
    en: "Marketing & Communications",
    ar: "التسويق والاتصالات",
    gr: "Marketing & Kommunikation",
  },
  {
    value: "REAL_ESTATE_PROPERTY",
    en: "Real Estate & Property",
    ar: "العقارات والممتلكات",
    gr: "Immobilien & Eigentum",
  },
  {
    value: "RETAIL_CONSUMER_PRODUCTS",
    en: "Retail & Consumer Products",
    ar: "التجزئة والمنتجات الاستهلاكية",
    gr: "Einzelhandel & Konsumgüter",
  },
  { value: "SALES", en: "Sales", ar: "المبيعات", gr: "Vertrieb" },
  {
    value: "SCIENCE_TECHNOLOGY",
    en: "Science & Technology",
    ar: "العلوم والتكنولوجيا",
    gr: "Wissenschaft & Technologie",
  },
  {
    value: "SPORT_RECREATION",
    en: "Sport & Recreation",
    ar: "الرياضة والترفيه",
    gr: "Sport & Freizeit",
  },
  {
    value: "TRADES_SERVICES",
    en: "Trades & Services",
    ar: "الحرف والخدمات",
    gr: "Handwerk & Dienstleistungen",
  },
  { value: "OTHER", en: "Other", ar: "أخرى", gr: "Andere" },
];
// ============================= Screening
export const QUESTIONTYPES = [
  { id: 1, label: "Text question" },
  { id: 3, label: "multiple choices" },
  { id: 4, label: "yes/no" },
  { id: 5, label: "number" },
  { id: 6, label: "range" },
];
// ==============Document type
export const DOCUMENT_TYPES = [
  { label: "pdf", value: "pdf" },
  { label: "Word", value: "word" },
  { label: "excal", value: "excal" },
  { label: "Jpg", value: "jpg" },
];
export const GENDERS=[
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Male", value: "NotMentioned" },

]
